<div class=" mb-3 p-1">
  <div class="row">
    <div class="col-sm-3">
        <button *ngIf="!isDashboard" type="button" class="btn btn-navigation mr-2" (click)="returnToSummary()"><i class="fas fa-arrow-left"></i> All {{observationTypeName}}{{pluralizeObservationType ? "s":""}}</button>
        <button *ngIf="isDashboard" type="button" class="btn btn-navigation mr-2" (click)="returnToDashboard()"><i class="fas fa-arrow-left"></i> {{observationTypeName}} Dashboard</button>
    </div>
    <div class="col-sm-6">
        <div class="h3 text-center">
            <span class="font-weight-bold">{{title ?? observationTypeName}}</span> ({{observationSchoolYear}})
        </div>
        <div class="text-center sm-6">
            <span><b>Evaluator</b>: {{observationEvaluator}} </span><span class="pl-5"><b>Date:</b> {{createdDate | date: "M/d/yyyy"}}</span>
        </div>
        <div class="text-center m-1">
            <span *ngIf="rubricLanguageLink!=''" class="pr-5">
                <a [href]="rubricLanguageLink" target="_blank">View Framework {{frameworkLabel}}</a></span>
            <span *ngIf="guidanceLink != ''">
                <a [href]="guidanceLink" target="_blank">Guide to {{observationTypeName}}</a></span>
        </div>
    </div>
    <div class="col-sm-3">

        <app-observation-actions class="float-right ml-2"
            [iconVisible]="true"
            [editEnabled]="false"
            [deleteEnabled]="false"
            [emailEnabled]="false"
            [printEnabled]="true"
            [attachmentsEnabled]="true"
            [attachmentsCount]="observationFiles.length"
            [isInsideObservation]="true"
            (click)="$event.stopPropagation()"
            [observationSummary]="observationSummary"
            (refreshListing)="refreshListing()"
            ></app-observation-actions>

            <observation-attachments class="float-right" [permissionsAll]="[PermissionTypes.FILE_ATTACHMENTS]"
              [observationFiles]="observationFiles"
              [observationSummary]="observationSummary"
              ></observation-attachments>
  </div>
</div>
